/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type CreateDirectorySlackConversationMutationVariables = Types.Exact<{
  targetClaimId: Types.Scalars["Int"];
}>;

export type CreateDirectorySlackConversationMutation = Pick<
  Types.Mutation,
  "createDirectorySlackConversation"
>;

export const CreateDirectorySlackConversationDocument = gql`
  mutation CreateDirectorySlackConversation($targetClaimId: Int!) {
    createDirectorySlackConversation(target_claim_id: $targetClaimId)
  }
`;

/**
 * __useCreateDirectorySlackConversationMutation__
 *
 * To run a mutation, you first call `useCreateDirectorySlackConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectorySlackConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectorySlackConversationMutation, { data, loading, error }] = useCreateDirectorySlackConversationMutation({
 *   variables: {
 *      targetClaimId: // value for 'targetClaimId'
 *   },
 * });
 */
export function useCreateDirectorySlackConversationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateDirectorySlackConversationMutation,
    CreateDirectorySlackConversationMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateDirectorySlackConversationMutation,
    CreateDirectorySlackConversationMutationVariables
  >(CreateDirectorySlackConversationDocument, baseOptions);
}
export type CreateDirectorySlackConversationMutationHookResult = ReturnType<
  typeof useCreateDirectorySlackConversationMutation
>;
export type CreateDirectorySlackConversationMutationResult =
  ApolloReactCommon.MutationResult<CreateDirectorySlackConversationMutation>;
export type CreateDirectorySlackConversationMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateDirectorySlackConversationMutation,
    CreateDirectorySlackConversationMutationVariables
  >;
